import { color, Text } from '@morressier/ts';
import styled from 'styled-components';

export const AvatarWrapper = styled.div.withConfig({
  componentId: 'SubmissionCardAvatarWrapper'
} as any)`
  display: flex;
  align-items: center;
  margin-top: 5px;
  > * {
    margin-right: 6px;
  }
  > *:last-child {
    margin-right: 0px;
  }
`;

export const Title = styled(Text)
  .withConfig({
    componentId: 'SubmissionCardTitle'
  } as any)
  .attrs({
    textAs: 'a',
    size: 'body1_new',
    fontWeight: 'bold'
  })`
  max-height: 48px;
  text-decoration: none;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const MainTitle = styled(Text).attrs({
  textAs: 'div',
  size: 'body2_new'
})`
  display: flex;
  align-items: center;
  text-transform: uppercase;
  font-weight: 600;
  margin-bottom: 16px;
`;

export const Author = styled(Text).attrs({
  textAs: 'div',
  size: 'body1_new'
})`
  max-width: 300px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;
